import { ApiProject } from '@api/api';
import { BaseState, LoadingState } from '@core/utility/state';

export interface ProjectState extends BaseState {
  project: ApiProject | null;
  projectList: ApiProject[];
  selectedProjectId: string | null;
}

export const initialProjectState: ProjectState = {
  project: null,
  projectList: [] as ApiProject[],
  requestState: LoadingState.INIT,
  selectedProjectId: null,
};
